import styled from "styled-components";

export const Button = styled.button`
  background-color: transparent;
  color: white;
  /* width: 30px; */
  height: 30px;
  display: grid;
  place-items: center;
  border: none;
  cursor: pointer;
  transition: all 200ms;
`